import React, { useState, useEffect } from "react";
import Header from "./Header";
import apiService from "../Services/apiService";
import { useNavigate } from "react-router-dom";
import { Popover, IconButton, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const CreateNew = () => {
    const token = localStorage.getItem("JWTToken");
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        SurveyName: '',
        SurveyDescription: '',
        Image: null,
    });

    useEffect(() => {
        if (!token) {
            navigate("/Login");
        }
    }, [token, navigate]);

    const [errors, setErrors] = useState({
        SurveyName: '',
        SurveyDescription: '',
        Image: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData({
            ...formData,
            Image: file,
        });
    };

    const validateForm = () => {
        let formIsValid = true;
        let errors = {};

        if (!formData.SurveyName.trim()) {
            errors.SurveyName = "Survey Name is required";
        } else if (!/^[A-Za-z\s]+$/.test(formData.SurveyName)) {
            errors.SurveyName = "Survey Name can only contain letters";
        }

        if (!formData.SurveyDescription.trim()) {
            errors.SurveyDescription = "Survey Description is required.";
        }

        if (formData.Image && !['image/jpeg', 'image/png', 'image/gif', 'image/bmp'].includes(formData.Image.type)) {
            errors.Image = "Only image files (JPG, PNG, GIF, BMP) are allowed.";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        const SubmitformData = new FormData();
        SubmitformData.append('Token', token);
        SubmitformData.append('Image', formData.Image);
        SubmitformData.append('SurveyName', formData.SurveyName);
        SubmitformData.append('SurveyDescription', formData.SurveyDescription);

        try {
            const response = await apiService.createSurvey(SubmitformData);
            console.log(response);
            if(response){
                if(response.STATUS === "SUCCESS"){
                    alert(response.MESSAGE);
                    navigate(`/ManageSurvey/${response.SurveyUID}`);
                }
                else{
                    alert(response.MESSAGE);
                }
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while creating the survey.");
        }
    };

    const BackBtnClick = () => {
        const isConfirmed = window.confirm("Are you sure you want to go to the Survey List? Your data will not be saved.");
        if (isConfirmed) {
            navigate("/SurveyList");
        }
    };

    // Popover state for info button
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "image-info-popover" : undefined;

    return (
        <>
            <Header />
            <div className="text-custom bg-Truvey">
                <div className="bg-grey2 py-4">
                    <div className="container">
                        <a className="fs-18 BackBtn" onClick={BackBtnClick}>
                            <i className="fa-solid fa-arrow-left TruveyColor"></i>
                        </a>
                        <span className="fs-18"> / Create New</span>
                    </div>
                </div>
                <div className="container py-4">
                    <div className="card p-3 col-7 m-auto p-2 boxshadow border-0">
                        <div className="card-body">
                            <h2 className="text-center p-3">Create Survey</h2>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="SurveyName">Survey Name: <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        type="text"
                                        id="SurveyName"
                                        name="SurveyName"
                                        className="form-control text-capitalize"
                                        value={formData.SurveyName}
                                        onChange={handleChange}
                                    />
                                    <span className="text-danger">{errors.SurveyName}</span>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="SurveyDescription">Survey Description: <span style={{ color: 'red' }}>*</span></label>
                                    <textarea
                                        id="SurveyDescription"
                                        name="SurveyDescription"
                                        rows="4"
                                        className="form-control"
                                        value={formData.SurveyDescription}
                                        onChange={handleChange}
                                    />
                                    <span className="text-danger">{errors.SurveyDescription}</span>
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="Image">
                                        Image:
                                        <IconButton size="small" className="ms-2" onClick={handleClick}>
                                            <InfoIcon fontSize="small" />
                                        </IconButton>
                                    </label>
                                    <input
                                        type="file"
                                        id="Image"
                                        name="Image"
                                        className="form-control mb-3"
                                        accept=".jpg, .jpeg, .gif, .png, .bmp"
                                        onChange={handleFileChange}
                                    />
                                    <span className="text-danger">{errors.Image}</span>

                                    {/* Popover for Info */}
                                    <Popover
                                        id={id}
                                        open={open}
                                        anchorEl={anchorEl}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: "center",
                                            horizontal: "right",
                                        }}
                                        transformOrigin={{
                                            vertical: "center",
                                            horizontal: "left",
                                        }}
                                        PaperProps={{
                                            sx: { padding: 2, backgroundColor: "#fff", boxShadow: 3 },
                                        }}
                                    >
                                        <Typography variant="body2">
                                            Supported formats: <strong>.jpg, .jpeg, .gif, .png, .bmp</strong><br />
                                            Max file size: <strong>200 KB</strong>
                                        </Typography>
                                    </Popover>
                                </div>

                                <hr />
                                <div className="text-center">
                                    <button type="submit" onClick={(e) => { e.preventDefault(); handleSubmit(); }} className="btn btn-custom col-8 mt-3 mx-auto">
                                        Create Survey
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateNew;
